import { supplier } from './../../../../suppliers/models/supplier';
import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { OrdersService } from '../../../../orders/services/orders/orders.service';
import { BudgetDetails, AdditionalCost } from '../../../../orders/models/budget';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AlertComponent } from '../alert/alert.component';
import { BudgetsService } from '../../../../orders/services/budgets/budgets.service';
import {Router} from '@angular/router';
import { LoaderDialogComponent } from '../../loader-dialog/loader-dialog.component';
import { finalize } from 'rxjs';

export interface BudgetApiResponse {
  orderId: string;
  budget: {
    id: string;
    supplierId: string;
    supplierCorporateName: string;
    budgetItems: BudgetItem[];
    additionalCosts: BudgetAdditionalCost[];
    costCenter: string;
    budgetResponseDate: string;
    paymentTermDays: number;
    deliveryTermDays: number;
    totalValue: number;
  };
  OrderStatus: string;
  generalRemarks: string;
}

export interface BudgetItem {
  id: number;
  orderItemId: number;
  itemId: number;
  orderItemName: string;
  partNumber: string;
  category: string;
  manufacturer: string;
  availableQuantity: number;
  requestedQuantity: number;
  unitValue: number;
  totalValue: number;
}

export interface BudgetAdditionalCost {
  id: number;
  costType: {
    id: number;
    costType: string;
  };
  description: string;
  value: number;
}

@Component({
  selector: 'app-budgets-approval-dialog',
  templateUrl: './budgets-approval.component.html',
  styleUrls: ['./budgets-approval.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    TranslateModule,
    MatButtonModule,
    FlexLayoutModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
  ],
})
export class BudgetsApprovalComponent implements OnInit {
  @Output() budgetApproved = new EventEmitter<boolean>(false);
  budgetItems: BudgetDetails[] = [];
  additionalCosts: AdditionalCost[] = [];
  totalCost: number = 0;
  status: string = '';
  generalRemarks: string = '';
  totalValue: number = 0;

  displayedColumnsBudget: string[] = [
    'codItem',
    'partNumber',
    'item',
    'category',
    'manufacturer',
    'quantity',
    'unitPrice',
    'totalValue',
  ];
  displayedColumnsAdditional: string[] = [
    'costType',
    'description',
    'totalValue',
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: BudgetApiResponse,
    private dialog: MatDialog,
    private ordersService: OrdersService,
    private dialogRef: MatDialogRef<BudgetsApprovalComponent>,
    private router: Router,
    private budgetsService: BudgetsService
  ) {
    dialogRef.disableClose = true;
    this.totalValue = this.data.budget.totalValue;
    this.status = this.data.OrderStatus;
    this.generalRemarks = this.data.generalRemarks;
  }

  ngOnInit() {
    this.mapBudgetData();
  }

  mapBudgetData() {
    if (this.data && this.data.budget) {
      this.budgetItems = this.data.budget.budgetItems.map((item: BudgetItem) => ({
        item: item.orderItemName,
        codItem: item.itemId,
        partNumber: item.partNumber,
        category: item.category,
        manufacturer:  item.manufacturer,
        quantity: item.availableQuantity,
        unitPrice: item.unitValue,
        totalValue: item.unitValue * item.availableQuantity,
      }));

      this.additionalCosts = this.data.budget.additionalCosts.map((cost: BudgetAdditionalCost) => ({
        costType: cost.costType.costType,
        description: cost.description,
        totalValue: cost.value,
      }));
    }
  }

  confirmDialog() {
    const loader = this.dialog.open(LoaderDialogComponent, {
      disableClose: true,
    });
    this.budgetsService.approveBudget(+this.data.budget.id, +this.data.orderId)
      .pipe(finalize(() => loader.close()))
      .subscribe({
        next: () => {
          this.dialog.open(AlertComponent, {
            data: {
              title: 'alert.information',
              message: 'budget.budgetApproved',
            },
          }).afterClosed().subscribe(() => {
            this.budgetApproved.emit(true);
            this.dialogRef.close(true);
          });
        },
      });
  }
}
